import { Analysis, PossibleRootCauseCategory } from '.';

export class HormonesAnalysis extends Analysis {
    calculateInsights() {
        if (this.ba.antiMullerianHormone.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15005);
        } else if (this.ba.antiMullerianHormone.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15006);
        }

        // Cortisol AM/PM and DHEA-S interpretation moved to StressAdrenalAnalysis
        // (90020/90030, 90040/90050, 90060/90070).

        if (this.ba.dihydrotestosterone.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15060);
        } else if (this.ba.dihydrotestosterone.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15070);
        }

        if (this.ba.estradiolE2.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15080);
        } else if (this.ba.estradiolE2.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15090);
        }

        if (this.ba.estriolE3.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15100);
        } else if (this.ba.estriolE3.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15110);
        }

        if (this.ba.estrogensTotal.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15120);
        } else if (this.ba.estrogensTotal.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15130);
        }

        if (this.ba.estroneE1.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15140);
        } else if (this.ba.estroneE1.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15150);
        }

        if (this.ba.fsh.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15160);
        } else if (this.ba.fsh.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15170);
        }

        if (this.ba.hCG.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15180);
        } else if (this.ba.hCG.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15190);
        }

        if (this.ba.igf1.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15192);
        } else if (this.ba.igf1.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15194);
        }

        if (this.ba.lh.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15200);
        } else if (this.ba.lh.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15210);
        }

        // Pregnenolone interpretation moved to StressAdrenalAnalysis (90080/90090).

        if (this.ba.progesterone.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15240);
        } else if (this.ba.progesterone.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15250);
        }

        if (this.ba.hydroxyprogesterone17.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15260);
        } else if (this.ba.hydroxyprogesterone17.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15270);
        }

        if (this.ba.prolactin.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15280);
        } else if (this.ba.prolactin.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15290);
        }

        if (this.ba.prolactinLactating.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15300);
        } else if (this.ba.prolactinLactating.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15310);
        }

        if (this.ba.shbg.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15320);
        } else if (this.ba.shbg.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15330);
        }

        if (this.ba.testosteroneBioavailable.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15340);
        } else if (this.ba.testosteroneBioavailable.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15350);
        }

        if (this.ba.testosteroneBioavailablePercent.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15360);
        } else if (this.ba.testosteroneBioavailablePercent.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15370);
        }

        if (this.ba.testosteroneFreeCalc.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15380);
        } else if (this.ba.testosteroneFreeCalc.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15390);
        }

        if (this.ba.testosteroneFreeDirect.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15400);
        } else if (this.ba.testosteroneFreeDirect.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15410);
        }

        if (this.ba.testosteroneTotal.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15420);
        } else if (this.ba.testosteroneTotal.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15430);
        }

        if (this.ba.testosteroneTotalLCMS.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15440);
        } else if (this.ba.testosteroneTotalLCMS.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_15450);
        }
    }
}